import React from 'react';
import { services } from '../mockData';
import * as LucideIcons from 'lucide-react';

const Services = () => {
  return (
    <div className="min-h-screen" data-testid="services-page">
      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden mt-24">
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1489274495757-95c7c837b101?q=80&w=2070&auto=format&fit=crop"
            alt="Professional garment care"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        <div className="relative z-10 text-center px-4">
          <h1
            className="text-5xl md:text-6xl font-bold text-white mb-4"
            style={{ fontFamily: '"Cinzel", serif' }}
          >
            Our Services
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Expert care for every garment, every time
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const Icon = LucideIcons[service.icon];
              return (
                <div
                  key={service.id}
                  className="group p-8 bg-white border-2 border-gray-200 rounded-lg hover:border-[#1F2D3D] transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
                  style={{
                    animationDelay: `${index * 100}ms`
                  }}
                >
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-[#1F2D3D]/10 rounded-full mb-6 group-hover:bg-[#1F2D3D] transition-all duration-300">
                    {Icon && (
                      <Icon
                        className="text-[#1F2D3D] group-hover:text-white transition-colors duration-300"
                        size={32}
                      />
                    )}
                  </div>
                  <h3
                    className="text-2xl font-semibold text-[#1F2D3D] mb-4"
                    style={{ fontFamily: '"Cinzel", serif' }}
                  >
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2
              className="text-4xl md:text-5xl font-bold text-[#1F2D3D] mb-4"
              style={{ fontFamily: '"Cinzel", serif' }}
            >
              Our Process
            </h2>
            <div className="w-24 h-1 bg-[#1F2D3D] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { step: '1', title: 'Collection', desc: 'Schedule a pickup to collect your laundry or dry cleaning' },
              { step: '2', title: 'Inspection', desc: 'Expert examination and tagging of each item' },
              { step: '3', title: 'Cleaning', desc: 'Professional cleaning using latest technology and expertise' },
              { step: '4', title: 'Delivery', desc: 'Fresh, perfectly cleaned garments delivered back to your door' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-[#1F2D3D] text-white rounded-full mb-4 text-2xl font-bold" style={{ fontFamily: '"Cinzel", serif' }}>
                  {item.step}
                </div>
                <h3 className="text-xl font-semibold text-[#1F2D3D] mb-2" style={{ fontFamily: '"Cinzel", serif' }}>
                  {item.title}
                </h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
